import { Button, ButtonProps } from "@mui/material";
import { resolveMprcRadiusSize } from "components/styles/resolvers";
import * as React from "react";

interface IMprcButtonProps {
    text?: string;
    rounded?: boolean;
}

export type MprcButtonProps = IMprcButtonProps & ButtonProps;

export const MprcButton = React.forwardRef<HTMLButtonElement, MprcButtonProps>(({ children, text, rounded, sx, ...rest }, ref) => {
    return (
        <Button
            {...rest}
            ref={ref}
            sx={
                {
                    ...sx,
                    borderRadius: rounded ? resolveMprcRadiusSize("sm") : undefined
                }
            }
        >
            {text && <span>{text}</span>}
            {children}
        </Button>
    );
});
